import { ActiveExperienceViewType } from './ActiveExperienceViewType';

export const ActiveExperienceViewTypeOptions = [
    {
        id: ActiveExperienceViewType.NonBFIExperience,
        text: 'Non-BFI Experience',
    },
    {
        id: ActiveExperienceViewType.BFIExperience,
        text: 'BFI Experience',
    },
];
